import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import {Link} from 'gatsby'


import shipping from "../../../static/spedycja.jpg"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { services } from "../../services"

import HeaderSlider from "../../components/slider/HeaderSlider"
import HeaderSliderItem from "../../components/slider/HeaderSliderItem"
import Section from "../../components/Section"
import SectionContext from "../../components/SectionContext"
import StyledButton from "../../components/StyledButton"
import SectionHeading from "../../components/SectionHeading"
import Text from "../../components/Text"
import Row from "../../components/Row"
import Card from "../../components/Card"
import Information from "../../components/Information"

const ShippingPage = () => {
  const servicesList = services[2].details.map(service => (
    <Card {...service} key={service.id} />
  ))

  return (
    <Layout>
      <Seo
        title="Kozbitrans - spedycja międzynarodowa"
        description="Kozbitrans oferuje usługę spedycji międzynarodowej. Organizujemy cały proces transportu, od rozpoczęcia współpracy po finalizację zamówienia."
      />
      <HeaderSlider>
        <HeaderSliderItem link={shipping}>
          <h1 className="item__content__main-heading">Spedycja</h1>
          <h2 className="item__content__sub-heading">
            Usługi spedycji na terenie Polski i Europy Zachodniej
          </h2>
        </HeaderSliderItem>
      </HeaderSlider>
      <Information />
      <Section id="uslugi">
        <Row>
          <h2 className="services__heading">
            <span className="line">Nasza firma oferuje usługi spedycyjne.</span>
            <span className="line">Co zyskujesz korzystając z tej usługi?</span>
          </h2>
        </Row>
        <Row>{servicesList}</Row>
      </Section>
      <Section id="historia" color="white">
        <SectionHeading>Czym jest spedycja?</SectionHeading>
        <Row nowrap centered>
          <SectionContext title="Kozbitrans - usługa spedycji międzynarodowej">
            <Text>
              Zajmujemy się organizajcą procesu transportu, pilnujemy, aby
              tworaz został odebrany i dostarczony w wyznaczone miejsce w
              odpowiednim czasie. Każdemu zależy na tym, aby jego towar dotarł
              do celu na czas i w nienaruszonym stanie, dlatego dobieramy
              odpowiedniego przewoźnika na podstawie czasu realizacji zlecenia,
              oraz poziomu świadczonych usług w przedziale cenowym wyznaczonym
              przez klienta. Wszelkie formalności związane z odprawą celną
              uzupełniamy z góry, aby transport przebiegł sprawnie i bez
              komplikacji. Nasi klienci są na bieżąco informowani o postępach
              realizacji zlecenia.
            </Text>
            <StyledButton category="reference">
              <Link to="/#kontakt">Skontaktuj się</Link>
            </StyledButton>
          </SectionContext>
          <div className="section-wrapper__image">
            <StaticImage
              src="../../images/spedytor.png"
              alt="Umowa biznesowa"
            />
          </div>
        </Row>
      </Section>
    </Layout>
  )
}

export default ShippingPage